import { BaseQuery, QueryConfig, QueryResponse, QueryResult } from "@/shared/types/base";
import { Usuario } from "@/shared/types/usuario"; 
import { removeNullOrEmptyKeys, sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";

export interface UsuariosQuery extends BaseQuery {
    nombre?: string,
    numDocumento?: string,
    telefono?: string,
    direccion?: string,
    email?: string,
    organizacionId?: string,
}

export async function getAllUsuarios(query?: UsuariosQuery): Promise<QueryResponse<Usuario>> {
    await sleep(1000);
    const response = await api.get("usuarios", { params: removeNullOrEmptyKeys(query) });
    return response.data;
}

export function useGetAllUsuariosQuery(query: UsuariosQuery = {}, queryConfig: QueryConfig<QueryResponse<Usuario>> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getAllUsuarios(query),
        queryKey: ["usuarios", query],
    })
}

export interface GetAllUsuarioQueryProps{
    query:UsuariosQuery,
    queryConfig?: QueryConfig<QueryResponse<Usuario>>,
    children:(queryResult:QueryResult<QueryResponse<Usuario>>)=>ReactNode
}

export function GetAllUsuariosQuery({
    query,
    queryConfig,
    children
}:GetAllUsuarioQueryProps){
    const queryResult = useGetAllUsuariosQuery(query, queryConfig);
    return children&&children(queryResult);
}